export enum FilterType {
	None,
	Text,
	Numeric,
	Date,
	RangeDate,
	Boolean,
	List,
	ListMultiple,
	NumericComparison,
	TextEquality,
	TextInequality,
}
